import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  Category,
  StoreCategoryPayload,
  UpdateCategoryPayload,
} from '../../models/catalog/category.model';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  #categories = new BehaviorSubject<Category[]>([]);
  public categories$ = this.#categories.asObservable();
  public categories = toSignal(this.categories$, { initialValue: [] });

  getCategories() {
    this.#http
      .get<{ data: Category[] }>(`${this.#apiUrl}/api/admin/catalog/categories`)
      .subscribe({
        next: (response) => this.#categories.next(response.data ?? []),
        error: (e) => console.log(e),
      });
  }

  createCategory(payload: StoreCategoryPayload): Observable<{ data: Category }> {
    return this.#http.post<{ data: Category }>(
      `${this.#apiUrl}/api/admin/catalog/categories`,
      payload,
    );
  }

  updateCategory(
    id: number,
    payload: UpdateCategoryPayload,
  ): Observable<{ data: Category }> {
    return this.#http.patch<{ data: Category }>(
      `${this.#apiUrl}/api/admin/catalog/categories/${id}`,
      payload,
    );
  }

  deleteCategory(id: number): Observable<unknown> {
    return this.#http.delete(
      `${this.#apiUrl}/api/admin/catalog/categories/${id}`,
    );
  }
}
